import type { ReactNode } from 'react';
import classes from './StatTile.module.css';

export interface StatTileProps {
  icon: ReactNode;
  label: string;
  value: number | string;
  /**
   * Kartın tonu (personel-mlc-calisma-dinlenme.jpeg: Total Crew, Compliant, Warning, Violation):
   * tonlu kartta ikon dolu daire, zemin hafif renkli.
   */
  tone?: 'default' | 'success' | 'warning' | 'danger';
  /**
   * Dar kartta etiket iki satıra iner (kesilmez); ör. beş kartlı envanter özeti. Etiket her kartta
   * iki satır yer kaplar, böylece yan yana kartların değerleri aynı hizada kalır.
   */
  wrapLabel?: boolean;
  /**
   * `tinted` (varsayılan): tonlu kartta hafif renkli zemin ve dolu ikon dairesi (MLC özeti).
   * `plain`: beyaz kart, nötr kenar; ton yalnız değerde ve ikonda (envanter özeti; M6f G1-08).
   */
  variant?: 'tinted' | 'plain';
}

/** Özet kartı: yuvarlak ikon, etiket ve büyük değer (BGM özet kartları). */
export function StatTile({
  icon,
  label,
  value,
  tone = 'default',
  wrapLabel,
  variant = 'tinted',
}: StatTileProps) {
  return (
    <div
      className={classes.tile}
      data-tone={tone}
      data-variant={variant}
      data-wrap={wrapLabel || undefined}
    >
      <span className={classes.icon} aria-hidden>
        {icon}
      </span>
      <div className={classes.body}>
        <span className={classes.label}>{label}</span>
        <span className={classes.value}>{value}</span>
      </div>
    </div>
  );
}
